const DEFAULT_TITLE = 'artifact-document';

function text(value) {
  return String(value ?? '').trim();
}

function formatDateTag(now = new Date()) {
  const date = now instanceof Date ? now : new Date(now);
  if (Number.isNaN(date.getTime())) {
    return '';
  }
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

function sanitizeFilenamePart(value = '') {
  return text(value)
    .replace(/[（(]\s*(草稿|已生成|需更新|失败|待确认|最终版)\s*[)）]/g, '')
    .replace(/^#{1,6}\s*/, '')
    .replace(/[\\/:*?"<>|]+/g, '-')
    .replace(/\s+/g, '')
    .replace(/_+/g, '_')
    .replace(/-+/g, '-')
    .replace(/^[-_]|[-_]$/g, '')
    .slice(0, 72);
}

function resolveMarkdownHeading(content = '') {
  return text(content)
    .split(/\r?\n/)
    .map((line) => text(line))
    .find((line) => /^#{1,2}\s+\S/.test(line)) || '';
}

function normalizeExtension(extension = 'md') {
  const normalized = text(extension).replace(/^\./, '').toLowerCase();
  return normalized || 'md';
}

export function buildArtifactDownloadFilename({
  content = '',
  extension = 'md',
  now = new Date(),
  statusLabel = '',
  title,
  typeLabel,
} = {}) {
  const dateTag = formatDateTag(now);
  const subject = sanitizeFilenamePart(resolveMarkdownHeading(content) || title) || DEFAULT_TITLE;
  const status = sanitizeFilenamePart(statusLabel);
  const type = sanitizeFilenamePart(typeLabel);
  const distinctType = [type].find((value) => value !== subject);
  const ext = normalizeExtension(extension);
  return `${[dateTag, subject, distinctType, status].filter(Boolean).join('__')}.${ext}`;
}
